/** @jsxImportSource ../i18n */
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { NavTabs } from './ui';

const TABS = [
  { id: 'global', to: '/reports', label: 'Rapport global' },
  { id: 'experts', to: '/reports/experts', label: "Rapports d'experts" },
  { id: 'live', to: '/reports/live', label: 'Débat en direct' },
  { id: 'scorecard', to: '/reports/scorecard', label: 'Bilan du panel' },
  { id: 'earnings', to: '/reports/earnings', label: 'Résultats' },
];

// Sub-navigation of the "Rapports quotidiens" menu: the consolidated (global)
// report archive, the expert panel's analyses, the live debate, the
// panel's scorecard and the earnings briefings.
const ReportsLayout = () => {
  const path = useLocation().pathname;
  const current = path.startsWith('/reports/live') ? 'live'
    : path.startsWith('/reports/experts') ? 'experts'
      : path.startsWith('/reports/scorecard') ? 'scorecard'
        : path.startsWith('/reports/earnings') ? 'earnings' : 'global';
  return (
    <div className="space-y-8">
      <NavTabs ariaLabel="Type de rapport" items={TABS} current={current} />
      <Outlet />
    </div>
  );
};

export default ReportsLayout;
